import React from 'react'
import FormLabel from '@material-ui/core/FormLabel'
import { makeStyles } from '@material-ui/core/styles'
import { TextValidator } from 'react-material-ui-form-validator'

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
    color: 'black',
  },
  formSection: {
    marginTop: 25,
  },
})

interface TransactionLimitPerDayInputProps {
  transactionLimitPerDay: string
  handleChangeTransactionLimitPerDay: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const TransactionLimitPerDayInput = ({
  transactionLimitPerDay,
  handleChangeTransactionLimitPerDay,
}: TransactionLimitPerDayInputProps) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.formSection}>
        <FormLabel className={classes.title}>Transaction Limit Per Day</FormLabel>
        <TextValidator
          name={'transactionLimitPerDay'}
          value={transactionLimitPerDay}
          margin="dense"
          id="name"
          type="name"
          validators={['required']}
          errorMessages={['Transaction limit per day is required']}
          style={{
            display: 'flex',
          }}
          inputProps={{
            maxLength: 20,
          }}
          onChange={handleChangeTransactionLimitPerDay}
        />
      </div>
    </>
  )
}
export default TransactionLimitPerDayInput
